<template>
  <span
    v-b-tooltip.hover
    :title="isOnline ? $t('trackVideo.videoOnline') : $t('trackVideo.videoOffline')"
    class="mc-trackvision-live-streaming__video-status-badge"
    :class="{
      online: isOnline,
      offline: !isOnline,
    }"
  >
    <i class="mc-fa icon-fill_video" />
    {{ isOnline ? 'ONLINE' : 'OFFLINE' }}
  </span>
</template>
<script>
export default {
  name: 'VideoStatusBadge',
  props: {
    isOnline: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
}
</script>
